import { Col, Form, Row } from '@valid-eval/shared-react-components';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import Checkbox from 'components/Form/Checkbox';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';
import { Artifact } from 'data/features/artifactsTypes';
import { Event } from 'data/features/eventsTypes';
import { useTranslation } from 'react-i18next';

type ArtifactFormProps = {
  methods: UseFormReturn<Artifact>;
  event: Event;
  onSubmit: (data: Artifact) => void;
};

export const ArtifactForm = ({ methods, event, onSubmit }: ArtifactFormProps) => {
  const { t } = useTranslation();
  // Watch artifact_type to conditionally show file_type field
  const watchedArtifactType = methods.watch('type_value');
  const showFileType = watchedArtifactType === 1; // '1' corresponds to 'file' type

  return (
    <FormProvider {...methods}>
      <Form onSubmit={methods.handleSubmit(onSubmit)}>
        <Row className="mb-2">
          <Col md={10}>
            <Input
              name="teams_and_organizers_name"
              label={t('event.form.artifact_name')}
              required
              autoFocus
            />
          </Col>
          <Col md={2} className="d-flex mt-3 pt-4">
            <Checkbox name="required" label={t('event.form.artifact_required')} hideTitle />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md={6}>
            <Select
              name="type_value"
              label={t('event.form.artifact_type')}
              placeholder={t('event.form.artifact_type_placeholder')}
              options={event.artifact_types || []}
              required
            />
          </Col>
          {showFileType && (
            <Col md={6}>
              <Select
                name="file_type_value"
                label={t('event.form.file_type')}
                placeholder={t('event.form.file_type_placeholder')}
                options={event.artifact_file_types || []}
                required
              />
            </Col>
          )}
        </Row>
        <Row className="mb-2">
          <Col md={12}>
            <Input name="content" label={t('event.form.artifact_instructions')} />
          </Col>
        </Row>
        <input type="submit" className="d-none" />
      </Form>
    </FormProvider>
  );
};

export default ArtifactForm;
